import { useLocation, Link } from "react-router-dom";
import { Container, Button } from "react-bootstrap";
import { useIntl, FormattedMessage } from 'react-intl';
import Config from "../config/Config";
import SectionWrapper from '../components/SectionWrapper';

export default function NotFound() {
    const { mainColor } = Config.appearance;

    const intl = useIntl();
    const location = useLocation();

    return (
        <Container className="mt-5">
            <SectionWrapper>
                <div className="d-flex flex-column align-items-center justify-content-center" style={{ padding: '30px' }}>
                    <h2 className="display-2 fw-bold text-danger">404</h2>
                    <p className="fs-3 mt-1">
                        <FormattedMessage
                            id="page_not_found"
                            values={{ page: (
                                <code>{location.pathname}</code>
                            )}}
                        />
                    </p>
                    <Link to={'/'} style={{ textDecoration: 'none' }}>
                        <Button variant="primary" className="mt-3" style={{
                            height: '55px',
                            borderRadius: '10px', // Right rounded corner
                            backgroundColor: mainColor,
                            border: 'none',
                            width: 'auto',
                            minWidth: '65px',
                        }}>
                           {intl.formatMessage({ id: "back_to_home"})}
                        </Button>
                    </Link>

                </div>
            </SectionWrapper>
        </Container>
    );
}